import { http } from './http';

export const acceptBd100Terms = () => {
  return http.put<any>('accept_bd100_terms');
};
